<template>
  <div class="mt-2 ml-2 mr-2">
    <div v-if="isManager">
      <b-row>
        <b-col>
          <b-card class="mb-2" border-variant="light" bg-variant="light">
            <p>Welcome to the SciStarter Integration!</p>
            <b-row>
              <b-col>
                <dl>
                  <dt><b>What is it?</b></dt>
                  <dd>The SciStarter integration is a way to automatically
                    connect your project to the <a href="https://scistarter.com" target="_blank"
                                                   rel="noopener noreferrer"> SciStarter platform</a> <i
                      class="fas fa-external-link-alt fa-xs"></i>
                  </dd>
                  <dt><b>Why should I use it?</b></dt>
                  <dd>SciStarter is the largest catalog of citizen science
                    projects. It can boost your CitSci project outreach to a
                    wide public audience through schools, libraries, media
                    outlets, and more—helping you attract volunteers and
                    amplify your impact. SciStarter can also promote your
                    project to other partnering platforms, like
                    ScienceNearMe.org. You’ll also get access to promotional
                    tools, volunteer recruitment features, and participation
                    insights.<br>
                    To improve your chances of approval, make sure your project
                    contributes to science, involves public participation, and
                    is clear and accessible. Include a strong title, clear steps,
                    audience information, location details, and visuals.
                  </dd>
                  <dt><b>How do I use it?</b></dt>
                  <dd>Integration is easy: once your project is published on
                    CitSci, you can enable the SciStarter integration toggle,
                    which will automatically share your project’s metadata with
                    SciStarter.<br>
                    Note that all submissions are reviewed by SciStarter’s
                    editorial team before going live. You may get an email from
                    SciStarter if they have any questions regarding your project.
                    To improve your chances of approval, make sure your project
                    contributes to science, involves public participation, and
                    is clear and accessible. Include a strong title, clear steps,
                    audience information, location details, and visuals.<br>
                    Every time you make a change to your project’s metadata on
                    CitSci, the updated information will automatically be sent
                    to SciStarter.
                  </dd>
                  <dt><b>What information is shared with SciStarter?</b></dt>
                  <dd>Project name, URL, goals, tasks, Facebook link,
                    organizations, banner image, your first name, last name and
                    email.
                  </dd>
                  <dt><b>What if I want to stop the integration?</b></dt>
                  <dd>You can disable the SciStarter integration anytime.
                    CitSci will immediately inform SciStarter to change your
                    project status to “hidden”. Your project will not be
                    visible or searchable on SciStarter and updates to your
                    project will not be sent to SciStarter. When you re-enable
                    the integration, your project info will be updated and
                    status set to “active” again on the SciStarter platform.
                  </dd>
                </dl>
              </b-col>
            </b-row>
            <b-row>
              <h6>Read more about the SciStarter API
                <a href="https://scistarter.org/api" target="_blank" rel="noopener noreferrer">here</a>
                <span><i class="fas fa-external-link-alt fa-xs"></i></span>
              </h6>
            </b-row>
            <b-alert
              variant="info"
              :show="showDismissibleAlert">
              Updating SciStarter...{{ countdown }} seconds
            </b-alert>
          </b-card>
          <b-card class="col-md-6 col-sm-12 mb-2" border-variant="light" bg-variant="light">
            <b-card-body>
              <b-row class="mb-3">
                <div class="mr-3"><b><u>Status:</u></b></div>
                <toggle-button v-if="projectVuex.projectState"
                               id="scistarter-btn"
                               color="#00c8f8"
                               v-model="projectVuex.isSciStarter"
                               :sync="true"
                               :labels="{ checked: 'ON', unchecked: 'OFF' }"
                               :width="65"
                               :disabled="false"
                               @change="toggleScistarter"
                />
                <toggle-button v-else
                               id="scistarter-btn"
                               color="#00c8f8"
                               :labels="{ checked: 'ON', unchecked: 'OFF' }"
                               :width="65"
                               :disabled="true"
                />
              </b-row>
              <b-row v-if="!projectVuex.projectState" class="mb-3">
                <b-col>
                  <div>
                    Your project needs to be Published before the SciStarter integration can be turned ON.<br>
                    Publish your project under
                    <b-link :to="{ name: 'ProjectEdit', params: { id: $route.params.id }}">Edit Project</b-link>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="projectVuex.projectState" class="mt-3">
                <b-col>
                  <b-link v-if="projectVuex && projectVuex.sciStarterID"
                          :href="scistarterURL" target="_blank">
                    <b-img
                      src="/assets/images/scistarter-affiliate-1200x332.png"
                      class="SciStarterLogoLink"
                      alt="Find us on SciStarter"
                      title="Clikc to view your project on SciStarter"
                      width="200"
                      fluid
                    >
                    </b-img>
                    <br>
                    {{ scistarterURL }} <span><i class="fas fa-external-link-alt fa-xs"></i></span>
                  </b-link>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <div v-if="projectVuex.isSciStarter">
                  Your SciStarter Integration is turned ON.
                </div>
                <div v-else>
                  Your SciStarter Integration is turned OFF.
                </div>
              </b-row>
              <!-- MONA: enable this AFTER async is implemented
              <b-button v-if="projectVuex && projectVuex.isSciStarter"
                type="submit"
                variant="primary"
                @click="syncScistarterInfo()"
              >
              Sync project info with SciStarter
              </b-button><br>
              -->
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <RequiresManager v-else page="SciStarter Integration"></RequiresManager>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import RequiresManager from "../tabpermission/requiresManager.vue";

export default {
  components: {RequiresManager},

  data() {
    return {
      //alertShow: false,
      collapse: true,
      countdown: 0,
      //projectLocal: null,
      dismissSecs: 25,
      dismissCountDown: 0,
      isScistarter: null,
      showDismissibleAlert: false,
      timer: null,
    }
  },

  mounted() {
    if (this.projectVuex) {
      this.isScistarter = this.projectVuex.isScistarter;
    }
  },

  computed: {
    ...mapGetters({
      isManager: "project/get/isManager",
      projectVuex: "project/get/project",
    }),

    scistarterURL() {
      const urlArray = this.projectVuex.urlField.split("/");
      return `https://www.scistarter.org/${urlArray[urlArray.length - 1]}`;
    },
  },

  methods: {
    ...mapActions({
      editProject: "project/update/editProject",
    }),

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    /*
    syncScistarterInfo() {
      if (this.projectVuex.isSciStarter && this.projectVuex.sciStarterID) {
        console.log("MONA: yes!");
      }
      else {
        console.log("MONA: no!");
      }
    },
    */

    toggleScistarter() {
      // Clear any existing timer
      if (this.timer) {
        clearInterval(this.timer);
      }

      // Reset, show alert and update project
      this.countdown = 25;
      this.showDismissibleAlert = true;
      this.editProject({isSciStarter: this.projectVuex.isSciStarter});

      // Start countdown timer
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          // Auto dismiss the alert
          this.showDismissibleAlert = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },

  // Clean up the timer when component is destroyed
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};

</script>

<style lang="scss" scoped>
</style>
